<script>
import { defineComponent, toRefs } from 'vue'
import { useAspectRatio } from '../functions'
import { templateRef } from '@vueuse/core'
export default defineComponent({
  props: {
    aspectRatio: {
      type: [String, Number],
      required: false,
      default: null
    },
    tag: {
      type: String,
      required: false,
      default () {
        return 'div'
      }
    }
  },
  setup (props) {
    const { aspectRatio } = toRefs(props)
    const el = templateRef('el')
    let aspectStyle
    if (aspectRatio.value) {
      aspectStyle = useAspectRatio(el, aspectRatio)
    }
    return {
      aspectStyle
    }
  }
})
</script>

<template>
  <component :is="tag" ref="el" :style="aspectStyle">
    <slot />
  </component>
</template>
